import React from 'react';

const VideosSection = ({ videos, loading, onDelete, onCreate }) => {
  return (
    <div className="card bg-dark border-0 shadow-lg rounded-5 overflow-hidden border-top border-5 border-info">
      <div className="card-header bg-black bg-opacity-25 border-0 p-3 p-md-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <h5 className="mb-0 fw-black text-uppercase">Bibliothèque Cloud</h5>
        <button onClick={onCreate} className="btn btn-info rounded-pill fw-black text-uppercase px-4 btn-sm shadow-sm w-100 w-md-auto">
          + Nouveau Média
        </button>
      </div>
      <div className="card-body p-0">
        {loading ? (
          <div className="text-center py-5"><div className="spinner-border text-info"></div></div>
        ) : (
          <div className="table-responsive">
            <table className="table table-dark table-hover mb-0 align-middle">
              <thead className="bg-secondary bg-opacity-10">
                <tr className="text-secondary fw-black text-uppercase small" style={{ fontSize: '10px' }}>
                  <th className="px-4 py-3" style={{ minWidth: '250px' }}>Aperçu & Titre</th>
                  <th className="px-4 py-3">Catégorie</th>
                  <th className="px-4 py-3 text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {videos.map((v) => (
                  <tr key={v.id} className="border-bottom border-secondary border-opacity-10">
                    <td className="px-4 py-3">
                      <div className="d-flex align-items-center">
                        <i className="bi bi-play-circle-fill text-info fs-4 me-3 flex-shrink-0"></i>
                        <div className="text-truncate">
                          <div className="text-white fw-bold text-truncate">{v.title}</div>
                          <small className="text-secondary text-truncate d-block" style={{ maxWidth: '200px' }}>{v.url_video}</small>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="badge bg-info bg-opacity-10 text-info border border-info border-opacity-25 fw-bold text-uppercase" style={{ fontSize: '10px' }}>
                        {v.category || "Général"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-end">
                      <div className="d-flex justify-content-end gap-2">
                        <button className="btn btn-outline-info btn-sm rounded-circle" onClick={() => window.open(v.url_video, '_blank')}><i className="bi bi-eye"></i></button>
                        <button className="btn btn-outline-danger btn-sm rounded-circle" onClick={() => onDelete(v.id)}><i className="bi bi-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideosSection;